import {Button, Spinner, css} from '@sail/ui/deprecated';
import {useTheme} from '../ThemeProvider';

interface BrandedPrimaryButtonProps {
  onPress: () => void;
  disabled?: boolean;
  pending?: boolean;
  dataTestId?: string;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
}

export function SendUsAnEmailSubmitButton({
  onPress,
  disabled,
  pending,
  dataTestId,
  children,
  size = 'large',
}: BrandedPrimaryButtonProps) {
  const theme = useTheme();

  return (
    <Button
      size={size}
      type="primary"
      css={{
        width: 'fill',
        color: css.value(theme.onCtaTextColor),
        backgroundColor: css.value(theme.ctaColor),
        borderColor: css.value(theme.ctaColor),
        outlineColor: css.value(theme.ctaColor),
        '--button-background-color': css.value(theme.ctaColor),
        '--keyline': css.value(theme.ctaColor),
        keyline: css.value(theme.ctaColor),
        '&:hover': {
          backgroundColor: disabled
            ? css.value(theme.ctaColor)
            : css.value(theme.ctaHoverColor),
        },
        '&:focus': {
          outline: theme.focusVisibleOutline,
          focusRing: theme.focusVisibleOutline ? css.value('none') : undefined,
        },
      }}
      onPress={onPress}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {pending ? <Spinner /> : children}
    </Button>
  );
}
